export default __webpack_public_path__ + "static/media/PitcherAngle-LeftHandBatter.14e2a595.png";